import {ReactComponent as TerritoryNotActive} from '@/assets/svgs/advisors/TerritoryXNotActive.svg'
import {ReactComponent as TerritoryActive} from '@/assets/svgs/advisors/TerritoryXActive.svg'

const Index = ({
  status,
}: {
  status: 'ACTIVE' | 'PAID' | 'PAUSED' | null | undefined
}) => {
  return status ? (
    status === 'ACTIVE' ? (
      <TerritoryActive style={{position: 'absolute', bottom: 0, right: 0}} />
    ) : (
      <TerritoryNotActive style={{position: 'absolute', bottom: 0, right: 0}} />
    )
  ) : null
}

export default Index
